// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1256":"4471fa3a306c29a2","38546":"e39ae6a314ab92a7","50080":"d7155ce511420653","56558":"771335c4bc1c09bd","57621":"c6a79955814704f9","72951":"abf780cea46d2af6","81161":"cc78bf791fc7f777"}[chunkId] + ".css";
};